

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const NEWSLETTERGETALL= createAsyncThunk(
  "NewsletterGetAll/NewsletterGetAll",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const NewsletterGetAllSlice = createSlice({
  name: "NewsletterGetAllSlice",
  initialState: {
    NewsletterGetAll: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfNewsletterGetAll: (state) => {
        state.NewsletterGetAll.loading = false
        state.NewsletterGetAll.error = false
        state.NewsletterGetAll.data = []
        state.NewsletterGetAll.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(NEWSLETTERGETALL.fulfilled, (state, action) => {
      state.NewsletterGetAll = {
        ...state.NewsletterGetAll,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTERGETALL.pending, (state, action) => {
      state.NewsletterGetAll = {
        ...state.NewsletterGetAll,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTERGETALL.rejected, (state, action) => {
      state.NewsletterGetAll = {
        ...state.NewsletterGetAll,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const NewsletterGetAllAction = {
    NEWSLETTERGETALL,
};

export { NewsletterGetAllAction };
export default NewsletterGetAllSlice.reducer;
export const {setInitialStateOfNewsletterGetAll} = NewsletterGetAllSlice.actions
